export default __webpack_public_path__ + "static/demo_keberkesanan_sabun_champaca_6-b8e26afee563bfc7eb7ac88cd6fb90ff.mp4";